function getYoutubeId(url) {
    if (!url) return null;
    const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
    const match = url.match(regex);
    return match ? match[1] : null;
}

function hexToRgba(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function Poster({ info }) {
    if (!info) return null;

    const { background, backgroundVertical, backgroundType, heading, subheading, overlayColor, textShadeColor } = info.extra || {};

    const renderBg = (src, orientationClass) => {
        if (backgroundType === 'youtube-video') {
            const videoId = getYoutubeId(src);
            if (!videoId) return null;
            const embedSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&playsinline=1&rel=0`;
            return (
                <iframe
                    key={orientationClass}
                    className={`poster-video${orientationClass ? ` ${orientationClass}` : ''}`}
                    src={embedSrc}
                    title="background video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                />
            );
        }
        if (backgroundType === 'image' && src) {
            return <div key={orientationClass} className={`poster-image${orientationClass ? ` ${orientationClass}` : ''}`} style={{ backgroundImage: `url(${src})` }} />;
        }
        return null;
    };

    const renderBackground = () => {
        const hasBoth = background && backgroundVertical;
        if (hasBoth) {
            return (
                <>
                    {renderBg(background, 'poster-bg-horizontal')}
                    {renderBg(backgroundVertical, 'poster-bg-vertical')}
                </>
            );
        }
        return renderBg(background || backgroundVertical, null);
    };

    const overlayStyle = {};
    if (overlayColor) overlayStyle.color = overlayColor;
    if (textShadeColor) overlayStyle.textShadow = `0 2px 12px ${hexToRgba(textShadeColor, 0.6)}`;

    return (
        <div className="poster">
            <div className="poster-background">
                {renderBackground()}
            </div>
            <div className="poster-overlay" style={overlayStyle}>
                {heading && <h1 className="poster-heading">{heading}</h1>}
                {subheading && <p className="poster-subheading">{subheading}</p>}
            </div>
        </div>
    );
}

export default Poster;
